import * as type from '../actions/types';

const initialState = {
  deleting: false,
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.DELETE_DEAL_PENDING:
      return {
        ...state,
        deleting: true,
        error: false,
        errorMessage: '',
      };
    case type.DELETE_DEAL_SUCCESS:
      return {
        ...state,
        deleting: false,
        success: true,
      };
    case type.DELETE_DEAL_FAILURE:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        deleting: false,
      };

    case type.CLEAR_DELETE_DEAL:
      return {
        ...state,
        deleting: false,
        error: false,
        errorMessage: '',
        success: false,
      };

    default:
      return state;
  }
};
